// MAIL-LATE-WRITES-NO-TENANT-GUARD — the mail package's copy of the canonical
// "drop a reply that outlived its tenant" writer (chat/functions/
// sameWorkspaceWriter.js, tickets/functions/, workspace/functions/).
//
// WHY MAIL NEEDS ONE. Registering a key as workspace-scoped (the shell's
// state-app.js) wipes it ON the switch. It cannot stop a request ISSUED in
// workspace A from writing its reply into workspace B afterwards. Every setup
// read and every account write in this package writes a workspace-scoped key
// AFTER an `await`: a slow `mail.setup get` in Acme would otherwise paint
// Acme's providers, policy and mailbox addresses inside the workspace the
// person switched to.
//
// DROPPING is right rather than rerouting or retrying: the payload describes a
// workspace the user is no longer looking at, and PHASE-1 of the switch has
// already restored the correct empty for the one they are.
//
// CAPTURE BEFORE THE AWAIT. `sameWorkspaceWriter(root)` must be called on the
// SAME tick as the request, before the first `await` — it snapshots the
// workspace id at call time. Calling it inside the `.then()` snapshots the NEW
// workspace and the guard can never fire.
//
// A SUB-APP MUST NOT IMPORT THE SHELL, which is why this is a fourth copy
// rather than a re-export. Consumers inside this package import THIS module —
// never re-inline it.

// Both id shapes are live on root: `workspace.id` from the SDK's workspace
// payload and `workspace._id` from the raw Mongo document. Stringified so a
// numeric id and its string form never read as two different tenants.
export const mailWorkspaceId = (root) => String(root?.workspace?.id || root?.workspace?._id || '')

// Returns a `write(patch)` that applies the patch only while the workspace is
// still the one it was created in. Returns `true` when the patch landed and
// `false` when it was dropped, so a caller can tell the two apart (a silent
// no-op reads as success at the call site).
export const mailSameWorkspaceWriter = (root) => {
  const issuedFor = String(root?.workspace?.id || root?.workspace?._id || '')
  return (patch) => {
    if (String(root?.workspace?.id || root?.workspace?._id || '') !== issuedFor) return false
    root.update(patch)
    return true
  }
}
